var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "clinic-doctors-filter" },
    [
      _c("base-select", {
        staticClass: "base-select",
        attrs: {
          placeholder: _vm.$t("Специальность", _vm.options),
          "empty-placeholder": "----",
          options: _vm.specialities,
          "filter-function": _vm.applySearchFilter,
        },
        scopedSlots: _vm._u([
          {
            key: "value",
            fn: function ({ value }) {
              return [_vm._v("\n      " + _vm._s(value.name) + "\n    ")]
            },
          },
          {
            key: "item",
            fn: function ({
              filteredOptions,
              highlightedIndex,
              value,
              select,
            }) {
              return _vm._l(filteredOptions, function (option, i) {
                return _c(
                  "li",
                  {
                    key: option.trasnlit,
                    staticClass: "base-select__option",
                    class: {
                      "is-active": i === highlightedIndex,
                      "is-selected": value === option,
                    },
                    on: {
                      click: function ($event) {
                        return select(option)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
                )
              })
            },
          },
        ]),
        model: {
          value: _vm.filter.speciality,
          callback: function ($$v) {
            _vm.$set(_vm.filter, "speciality", $$v)
          },
          expression: "filter.speciality",
        },
      }),
      _vm._v(" "),
      _c("base-select", {
        staticClass: "base-select base-select_experience",
        attrs: {
          placeholder: _vm.$i18next.t("Стаж", _vm.options),
          options: _vm.experiences,
        },
        scopedSlots: _vm._u([
          {
            key: "value",
            fn: function ({ value }) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t(value.name, _vm.options)) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "item",
            fn: function ({
              filteredOptions,
              highlightedIndex,
              value,
              select,
            }) {
              return _vm._l(filteredOptions, function (option, i) {
                return _c(
                  "li",
                  {
                    key: option.name,
                    staticClass: "base-select__option",
                    class: {
                      "is-active": i === highlightedIndex,
                      "is-selected": value === option,
                    },
                    on: {
                      click: function ($event) {
                        return select(option)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t(option.name, _vm.options)) +
                        "\n      "
                    ),
                  ]
                )
              })
            },
          },
        ]),
        model: {
          value: _vm.filter.experience,
          callback: function ($$v) {
            _vm.$set(_vm.filter, "experience", $$v)
          },
          expression: "filter.experience",
        },
      }),
      _vm._v(" "),
      _c("gender-switch", {
        staticClass: "gender-switch",
        attrs: { options: _vm.genders },
        model: {
          value: _vm.filter.gender,
          callback: function ($$v) {
            _vm.$set(_vm.filter, "gender", $$v)
          },
          expression: "filter.gender",
        },
      }),
      _vm._v(" "),
      _c("base-checkbox", {
        staticClass: "base-checkbox",
        attrs: { label: _vm.$t("Вызов на дом", _vm.options) },
        model: {
          value: _vm.filter.isHomeCall,
          callback: function ($$v) {
            _vm.$set(_vm.filter, "isHomeCall", $$v)
          },
          expression: "filter.isHomeCall",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }